import { ShareResponse } from 'app/components/Shares/types';
import { SharedPlaylistResponse } from 'types/shares.types';

export const getSharedAudio = (
  shareResponse: ShareResponse | SharedPlaylistResponse
) =>
  'audio' in shareResponse.response
    ? shareResponse.response.audio.item
    : undefined;
